import {fromEvent} from 'rxjs';
import {map, tap} from 'rxjs/operators';
import * as qs from 'app/lib/helperjs';

export const WRAPPER_ATTRIBUTE = 'data-accordion';
export const BUTTON_ATTRIBUTE = 'data-accordion-target';
export const CONTENT_ATTRIBUTE = 'data-accordion-content';
export const ACTIVE_CLASS = 'active';

const buttons = qs.querySelectorAll(`[${BUTTON_ATTRIBUTE}]`);
const contents = qs.querySelectorAll(`[${CONTENT_ATTRIBUTE}]`);

export const Accordion = () => {
    if (buttons.length === 0 || contents.length === 0) {
        return;
    }

    fromEvent(buttons, 'click')
        .pipe(
            tap((event) => event.preventDefault()),
            map(resolveAccordionTargetFromEvent)
        )
        .subscribe((target) => {
            buttons.forEach((element) => {
                const isTargetElement = element.getAttribute(BUTTON_ATTRIBUTE) === target;

                qs.toggleClass(element, ACTIVE_CLASS, isTargetElement);
                qs.toggleClass(element.parentElement, ACTIVE_CLASS, isTargetElement);
            });
            contents.forEach((element) => qs.toggleClass(element, ACTIVE_CLASS, element.id === target.replace(/^#/, '')));
            setWindowHashLocation(target);
        });
};

export const setWindowHashLocation = (hash) => {
    if (history.pushState) {
        return history.pushState(null, null, hash);
    }

    window.location.hash = hash;
};

const resolveAccordionTargetFromEvent = (event) => {
    if (!event) {
        return;
    }

    if (event.target.hasAttribute(BUTTON_ATTRIBUTE)) {
        return event.target.getAttribute(BUTTON_ATTRIBUTE);
    }

    let parent = event.target;

    do {
        parent = parent.parentElement;
        if (parent.hasAttribute(BUTTON_ATTRIBUTE)) {
            return parent.getAttribute(BUTTON_ATTRIBUTE);
        }
    } while (!parent.parentElement.hasAttribute(BUTTON_ATTRIBUTE));
};
